<template>
  <div class="no-box-shadow-card card height-80 border-color-select">
    <div class="card-header height-80">
      <div class="imgFaceSansListe mgv-auto" v-if="firstLigne">
        <div class="imgFaceSansListe_logo">
        </div>
      </div>
      <img :src="logo" v-else-if="logo && !firstLigne" alt=""
           class="image is-32x32 mg-auto mgl-20px mgr-20px"/>
      <avatar :username="technicienInformation.technicien" v-else :size="32"
              class="mg-auto mgl-20px mgr-20px"/>
      <div class="columns is-multiline height-fit-content mgt-20px full-width">
        <div class="column is-12 pdv-0
            is-size-6 has-text-weight-bold height-fit-content has-text-link">
          {{ technicienInformation.technicien }}
        </div>
        <div class="column is-6 pdv-0
            is-size-7 height-fit-content is-size-7 has-text-default">
          {{ $t('chargeTravailTech.ressourceAndAffectationInfo.nbOts',
          { nbOt: technicienInformation.nbOts }) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Avatar from 'vue-avatar';
import getLogo from '@/services/general/getLogo';

export default {
  data() {
    return {
      logo: null,
    };
  },
  components: {
    Avatar,
  },
  props: {
    technicienInformation: {
      type: Object,
      required: true,
    },
    firstLigne: {
      type: Boolean,
      required: true,
    },
  },
  async mounted() {
    if (!this.technicienInformation.technicienId) return;
    this.logo = await getLogo(this.technicienInformation.technicienId);
  },
};

</script>
